import { useEffect } from 'react';
import useStores from '$src/hooks/useStores';
import { redirectToOnboardingProfessionalMonitoring, redirectToOnboardingSOSTurnOn, redirectToOnboardingSOSSetUp } from '$src/utils/redirect';
import useFeature from '$src/hooks/useFeature';

function useRedirectBasedOnMonitoringStatus(userId, locationId) {
  const {
    modesStore: { isMonitoringUnsupportedStatus, isMonitoringStatusSOSOff, isMonitoringStatusSOSSetupIncomplete, fetchMonitoringStatus },
    sessionStore: { isMobile },
  } = useStores();
  const [allowSOSSupport] = useFeature('stark-feature-allow-sos-support');

  useEffect(() => {
    async function fetch() {
      await fetchMonitoringStatus(userId, locationId);
    }

    fetch();
    if (isMonitoringUnsupportedStatus) {
      redirectToOnboardingProfessionalMonitoring(locationId);
    } else if (allowSOSSupport) {
      if (isMonitoringStatusSOSOff) {
        redirectToOnboardingSOSTurnOn(locationId);
      } else if (isMonitoringStatusSOSSetupIncomplete) {
        redirectToOnboardingSOSSetUp(locationId);
      }
    }
  }, [
    fetchMonitoringStatus,
    userId,
    locationId,
    isMonitoringUnsupportedStatus,
    isMonitoringStatusSOSOff,
    isMonitoringStatusSOSSetupIncomplete,
    allowSOSSupport,
    isMobile,
  ]);
}

export default useRedirectBasedOnMonitoringStatus;
